import {IGetAmplitudePropertySelectItemEventPropertiesParams} from "./get_amplitude_property_select_item_event_properties";
import {IAmplitudeItemListContext} from "./get_amplitude_view_item_event_properties";
import {trackAmplitudePropertySelectItem} from "./track_amplitude_property_select_item";

interface ITrackPropertySelectItemWithListContextParams {
    offer: IGetAmplitudePropertySelectItemEventPropertiesParams["offer"];
    property: IGetAmplitudePropertySelectItemEventPropertiesParams["property"];
    index: number;
    itemListContext?: IAmplitudeItemListContext | null;
}

export const trackPropertySelectItemWithListContext = (params: ITrackPropertySelectItemWithListContextParams) => {
    const {offer, property, index, itemListContext} = params;

    if (!itemListContext?.itemListId) {
        return;
    }

    trackAmplitudePropertySelectItem({
        offer,
        property,
        index,
        itemListId: itemListContext.itemListId,
        itemListName: itemListContext.itemListName
    });
};
import {IGetAmplitudePropertySelectItemEventPropertiesParams} from "./get_amplitude_property_select_item_event_properties";
import {IAmplitudeItemListContext} from "./get_amplitude_view_item_event_properties";
import {trackAmplitudePropertySelectItem} from "./track_amplitude_property_select_item";

interface ITrackPropertySelectItemWithListContextParams {
    offer: IGetAmplitudePropertySelectItemEventPropertiesParams["offer"];
    property: IGetAmplitudePropertySelectItemEventPropertiesParams["property"];
    index: number;
    itemListContext?: IAmplitudeItemListContext | null;
}

export const trackPropertySelectItemWithListContext = (params: ITrackPropertySelectItemWithListContextParams) => {
    const {offer, property, index, itemListContext} = params;

    if (!itemListContext?.itemListId) {
        return;
    }

    trackAmplitudePropertySelectItem({
        offer,
        property,
        index,
        itemListId: itemListContext.itemListId,
        itemListName: itemListContext.itemListName
    });
};
